module.exports = __webpack_public_path__ + "img/product-6-INTreport.ab7daf6c.png";